import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { fetchContentCollectionEntry } from 'b2b-apps/shop/content/redux/contentCollectionsEntries/actionCreators';
import { getCollectionEntryByIds } from 'b2b-apps/shop/content/redux/contentCollectionsEntries/selectors';
import { ContentCollectionEntryType } from 'b2b-apps/shop/content/redux/contentCollectionsEntries/types';

type UseCollectionEntryReturnType = RemoteRecord<ContentCollectionEntryType>;

const CONTENT_COLLECTION_ENTRY = {
  pages: 'jamei_static_pages',
  brandPages: 'jamei_brand_pages',
};

const useCollectionEntry = (
  collectionId: string,
  entryId: string,
): UseCollectionEntryReturnType => {
  const dispatch = useDispatch();
  const content = useSelector(
    useCallback(
      (state: State) => getCollectionEntryByIds(state, collectionId, entryId),
      [collectionId, entryId],
    ),
  );

  useEffect(
    (): void => {
      if (!content.isLoaded) {
        dispatch(fetchContentCollectionEntry(collectionId, entryId));
      }
    },
    [collectionId, content.isLoaded, dispatch, entryId],
  );
  return content;
};

export {
  CONTENT_COLLECTION_ENTRY,
  useCollectionEntry,
};
export type { UseCollectionEntryReturnType };
